import styled from "styled-components";

export const ErrorMessage = styled.span`
  font-size: ${(props) => props.theme.fontSizes[0]}px;
  color: #ff6262;
`;
